/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useEffect, useState } from "react";
import Container from "../components/Container";
import NavigationHeader from "../components/NavigationHeader";
import EmptyView from "../components/EmptyView";
import Button from "../components/ui/Button";
import Icon from "../components/ui/Icon";
import Text from "../components/ui/Text";
import { useBooking } from "../hooks/useBooking";
import { useStepManager } from "../hooks/useStepManager";
import { useTranslate } from "../hooks/useTranslate";
import { useFormatters } from "../hooks/useFormatters";
import useWidgetCallbackParams from "../hooks/useWidgetCallbackParams";
import { formatDateTime } from "../utils/helpers/formatters";
import { ROUTES } from "../constants/constants";

const WaitingListJoined = () => {
  const { _t } = useTranslate();
  const { selectedDate, resetBookingRequest } = useBooking();
  const { navigateToStep } = useStepManager();
  const { FormatDateTime } = useFormatters();
  const {
    serviceIds,
    location: preselectLocation,
    provider: preselectProvider,
    promotionCode: preselectCoupon,
  } = useWidgetCallbackParams();

  const hadPreselects =
    serviceIds.length > 0 || !!preselectLocation || !!preselectProvider || !!preselectCoupon;

  const [joinedDate] = useState(selectedDate);
  useEffect(() => {
    if (!hadPreselects) resetBookingRequest();
  }, [hadPreselects, resetBookingRequest]);

  const handleMakeAnotherBooking = () => {
    navigateToStep(ROUTES.HOME);
  };

  const [beforeDate, afterDate] = _t(
    "We'll email you as soon as a slot opens on %date%. Slots aren't reserved — book it from the link in the email before someone else does."
  ).split("%date%");

  const description = (
    <>
      {beforeDate}
      <Text as="span" weight="bold" color="dark">
        {FormatDateTime({ value: joinedDate, format: formatDateTime.FORMAT.DATE })}
      </Text>
      {afterDate}
    </>
  );

  return (
    <Container>
      <NavigationHeader location clientLogin />
      <EmptyView
        icon={Icon.CheckCircle}
        iconColor="success"
        size={108}
        title="You're on the waiting list"
        description={description}
        action={
          <Button variant="primary" title="Make another booking" onClick={handleMakeAnotherBooking} />
        }
      />
    </Container>
  );
};

export default WaitingListJoined;
